/**
 * Biblioteca de Logotipos e Emblemas Vetoriais Profissionais para MEI e Prestadores.
 * Permite que o prestador escolha um logotipo pronto de alta qualidade por segmento sem precisar criar um arquivo externo.
 */

export interface PresetLogo {
  id: string;
  nome: string;
  ramo: string;
  icone: string;
  svgDataUrl: string;
}

function svgToDataUrl(svg: string): string {
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg.trim())}`;
}

export const PRESET_LOGOS: PresetLogo[] = [
  {
    id: 'eletrica',
    nome: 'Elétrica & Energia',
    ramo: 'Eletricista Residencial e Predial',
    icone: '⚡',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#0f172a"/>
        <circle cx="60" cy="60" r="46" fill="#0f766e" opacity="0.3"/>
        <path d="M66 22 L36 64 L58 64 L50 98 L84 54 L62 54 Z" fill="#2dd4bf" stroke="#ffffff" stroke-width="2" stroke-linejoin="round"/>
        <circle cx="78" cy="38" r="4" fill="#fbbf24"/>
      </svg>
    `)
  },
  {
    id: 'pintura',
    nome: 'Pintura & Acabamento',
    ramo: 'Pintor e Tratamento de Superfícies',
    icone: '🎨',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#1e1b4b"/>
        <circle cx="60" cy="60" r="46" fill="#4338ca" opacity="0.3"/>
        <path d="M38 34 C38 28 82 28 82 34 L82 50 C82 56 38 56 38 50 Z" fill="#818cf8"/>
        <path d="M60 56 L60 82 C60 86 64 90 68 90 C72 90 76 86 76 82 L76 74" fill="none" stroke="#e0e7ff" stroke-width="6" stroke-linecap="round"/>
        <rect x="54" y="80" width="12" height="22" rx="4" fill="#fbbf24"/>
        <circle cx="44" cy="68" r="4" fill="#38bdf8"/>
        <circle cx="50" cy="74" r="3" fill="#38bdf8"/>
      </svg>
    `)
  },
  {
    id: 'obras',
    nome: 'Construção & Reformas',
    ramo: 'Pedreiro, Alvenaria e Reformas',
    icone: '🏗️',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#1c1917"/>
        <circle cx="60" cy="60" r="46" fill="#b45309" opacity="0.25"/>
        <path d="M32 88 L60 30 L88 88 Z" fill="none" stroke="#f59e0b" stroke-width="6" stroke-linejoin="round"/>
        <path d="M42 70 L78 70" stroke="#f59e0b" stroke-width="5"/>
        <rect x="52" y="58" width="16" height="30" rx="2" fill="#d97706"/>
        <circle cx="60" cy="46" r="4" fill="#ffffff"/>
      </svg>
    `)
  },
  {
    id: 'marcenaria',
    nome: 'Marcenaria & Móveis',
    ramo: 'Marceneiro e Móveis Planejados',
    icone: '🔨',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#292524"/>
        <circle cx="60" cy="60" r="46" fill="#78350f" opacity="0.3"/>
        <path d="M44 32 L76 32 L82 46 L38 46 Z" fill="#d97706"/>
        <rect x="55" y="46" width="10" height="48" rx="3" fill="#fde68a" stroke="#78350f" stroke-width="2"/>
        <path d="M36 40 L30 46 L36 52" fill="none" stroke="#fbbf24" stroke-width="3" stroke-linecap="round"/>
        <path d="M84 40 L90 46 L84 52" fill="none" stroke="#fbbf24" stroke-width="3" stroke-linecap="round"/>
      </svg>
    `)
  },
  {
    id: 'hidraulica',
    nome: 'Hidráulica & Encanamento',
    ramo: 'Encanador e Manutenção Hidráulica',
    icone: '🔧',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#0c4a6e"/>
        <circle cx="60" cy="60" r="46" fill="#0284c7" opacity="0.3"/>
        <path d="M60 26 C60 26 36 60 36 74 C36 87 47 98 60 98 C73 98 84 87 84 74 C84 60 60 26 60 26 Z" fill="#38bdf8"/>
        <path d="M50 72 C50 64 66 52 66 52 C66 52 70 64 70 72 C70 78 65 82 60 82 C55 82 50 78 50 72 Z" fill="#ffffff" opacity="0.8"/>
        <path d="M30 42 L42 30 L52 40 L40 52 Z" fill="#e0f2fe"/>
      </svg>
    `)
  },
  {
    id: 'mecanica',
    nome: 'Mecânica & Automotivo',
    ramo: 'Oficina Mecânica e Auto Elétrica',
    icone: '🚗',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#18181b"/>
        <circle cx="60" cy="60" r="46" fill="#ef4444" opacity="0.25"/>
        <circle cx="60" cy="60" r="28" fill="none" stroke="#f87171" stroke-width="8" stroke-dasharray="8 6"/>
        <circle cx="60" cy="60" r="14" fill="#ef4444"/>
        <circle cx="60" cy="60" r="6" fill="#18181b"/>
      </svg>
    `)
  },
  {
    id: 'ti',
    nome: 'TI & Tecnologia',
    ramo: 'Suporte Técnico, Redes e Computadores',
    icone: '💻',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#0f172a"/>
        <circle cx="60" cy="60" r="46" fill="#3b82f6" opacity="0.3"/>
        <rect x="30" y="32" width="60" height="42" rx="6" fill="#1e293b" stroke="#60a5fa" stroke-width="4"/>
        <rect x="36" y="38" width="48" height="30" rx="2" fill="#0f172a"/>
        <path d="M44 80 L76 80 L80 88 L40 88 Z" fill="#64748b"/>
        <path d="M42 53 L48 47 L42 41" fill="none" stroke="#34d399" stroke-width="3" stroke-linecap="round"/>
        <line x1="52" y1="53" x2="62" y2="53" stroke="#60a5fa" stroke-width="3" stroke-linecap="round"/>
      </svg>
    `)
  },
  {
    id: 'jardinagem',
    nome: 'Jardinagem & Paisagismo',
    ramo: 'Jardineiro e Manutenção de Áreas Verdes',
    icone: '🌿',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#064e3b"/>
        <circle cx="60" cy="60" r="46" fill="#10b981" opacity="0.25"/>
        <path d="M60 26 C40 40 34 68 44 86 C64 86 86 78 86 46 C74 46 64 36 60 26 Z" fill="#34d399"/>
        <path d="M44 86 C54 70 66 52 78 40" stroke="#065f46" stroke-width="4" stroke-linecap="round"/>
        <circle cx="48" cy="42" r="4" fill="#a7f3d0"/>
      </svg>
    `)
  },
  {
    id: 'limpeza',
    nome: 'Limpeza & Diarista',
    ramo: 'Serviços de Limpeza e Conservação',
    icone: '🧹',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#134e4a"/>
        <circle cx="60" cy="60" r="46" fill="#14b8a6" opacity="0.3"/>
        <path d="M60 22 L68 42 L88 50 L68 58 L60 78 L52 58 L32 50 L52 42 Z" fill="#2dd4bf"/>
        <path d="M80 68 L84 76 L92 80 L84 84 L80 92 L76 84 L68 80 L76 76 Z" fill="#fef08a"/>
        <circle cx="44" cy="78" r="6" fill="#99f6e4"/>
      </svg>
    `)
  },
  {
    id: 'refrigeracao',
    nome: 'Ar Condicionado & Refrigeração',
    ramo: 'Instalação e Manutenção de Climatização',
    icone: '❄️',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#0f2b48"/>
        <circle cx="60" cy="60" r="46" fill="#38bdf8" opacity="0.25"/>
        <path d="M60 22 L60 98 M22 60 L98 60 M33 33 L87 87 M33 87 L87 33" stroke="#38bdf8" stroke-width="5" stroke-linecap="round"/>
        <circle cx="60" cy="60" r="10" fill="#bae6fd" stroke="#0284c7" stroke-width="3"/>
      </svg>
    `)
  },
  {
    id: 'estetica',
    nome: 'Beleza & Barbearia',
    ramo: 'Barbearia, Cabeleireiro e Estética',
    icone: '✂️',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#2e1065"/>
        <circle cx="60" cy="60" r="46" fill="#a855f7" opacity="0.25"/>
        <path d="M38 78 C38 86 46 92 54 86 L60 76 L66 86 C74 92 82 86 82 78 C82 70 74 66 68 70 L60 56 L68 42 C74 46 82 42 82 34 C82 26 74 20 66 26 L60 36 L54 26 C46 20 38 26 38 34 C38 42 46 46 52 42 L60 56 L52 70 C46 66 38 70 38 78 Z" fill="#c084fc"/>
        <circle cx="60" cy="56" r="4" fill="#ffffff"/>
      </svg>
    `)
  },
  {
    id: 'consultoria',
    nome: 'Consultoria & Gestão',
    ramo: 'Consultor, Projetos e Serviços B2B',
    icone: '📊',
    svgDataUrl: svgToDataUrl(`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" width="120" height="120">
        <rect width="120" height="120" rx="28" fill="#111827"/>
        <circle cx="60" cy="60" r="46" fill="#10b981" opacity="0.25"/>
        <path d="M32 86 L48 66 L64 74 L88 42" fill="none" stroke="#34d399" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M72 42 L88 42 L88 58" fill="none" stroke="#34d399" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="48" cy="66" r="4" fill="#ffffff"/>
        <circle cx="64" cy="74" r="4" fill="#ffffff"/>
        <circle cx="88" cy="42" r="5" fill="#fbbf24"/>
      </svg>
    `)
  }
];

export function getPresetLogo(id: string): PresetLogo | undefined {
  return PRESET_LOGOS.find(l => l.id === id);
}
